// import BASE_API from '@/api/dataBase';
import { isIntValidator } from '@/validators';
export const formColumns = (ctx) => {
  return [
    {
      name: '制单日期',
      prop: 'contractCreateDate',
      type: 'date',
      disabled: true,
    },
    {
      name: '合同编号',
      prop: 'contractNo',
      type: 'input',
      placeholder: '自动生成',
      disabled: true,
    },
    {
      name: '合同名称',
      prop: 'contractName',
      type: 'input',
    },
    {
      name: '单据状态',
      prop: 'contractStatus',
      type: 'dict',
      dictType: 'contract_status',
      disabled: true,
      placeholder: '自动生成',
    },
    {
      name: '公司',
      prop: 'companyCode',
      type: 'select',
      value: 'personCompanyCode',
      label: 'personCompanyName',
      options: ctx.companyList,
      changeMethod: 'changeMethod',
    },
    {
      name: '业务部门',
      prop: 'departmentCode',
      type: 'select',
      value: 'personDepartmentCode',
      label: 'personDepartmentName',
      options: ctx.departmentList,
      changeMethod: 'changeMethod',
    },
    {
      name: '项目编号',
      prop: 'projectInitiationNo',
      searchType: 'projectListWumao',
      type: 'searchTableSpec',
      isMultiple: true,
      currentValue: ctx.baseInfoData?.projectInitiationNo
        ? ctx.baseInfoData?.projectInitiationNo
        : null,
      checkRowKeys: [
        ctx.baseInfoData.projectInitiationNo ? ctx.baseInfoData.projectInitiationNo : null,
      ],
      extraData: {
        projectInitiationStatusList: ['PIS04', 'PIS05', 'PIS07', 'PIS08'],
        platformtCompany: ctx.userInfo.companyCode,
        applyCompanyNo: ctx.userInfo.companyCode,
        applyCompanyName: ctx.userInfo.companyName,
      },
      changeMethod: 'changeMethod',
    },
    {
      name: '项目名称',
      prop: 'projectName',
      type: 'input',
      disabled: true,
      placeholder: '请输入项目名称',
    },
    // {
    //   name: '供应商名称',
    //   prop: 'supplierNo',
    //   type: 'searchTableSpec',
    //   searchType: 'supplier',
    //   extraData: {
    //     departmentCode: ctx.baseInfoData.departmentCode,
    //     companyCode: ctx.baseInfoData.companyCode, //选择公司后的供应商名称
    //   },
    //   isMultiple: true,
    //   changeMethod: 'changeMethod',
    //   currentValue: ctx.baseInfoData.supplierName,
    // },
    {
      prop: 'supplierNo',
      name: '供应商名称',
      type: 'searchTableSpec',
      searchType: 'supplier',
      extraData: {
        partnerTypes: 'HZHB02,HZHB03,HZHB09,HZHB11,HZHB13',
        departmentCode: ctx.baseInfoData.departmentCode, //部门
        companyCode: ctx.baseInfoData.companyCode, //公司
      },
      currentValue: ctx.baseInfoData.supplierName ? ctx.baseInfoData.supplierName : null,
      checkRowKeys: [ctx.baseInfoData.supplierNo ? ctx.baseInfoData.supplierNo : null],
      isMultiple: true,
      changeMethod: 'changeMethod',
    },
    // {
    //   name: '客户名称',
    //   prop: 'customerNo',
    //   type: 'searchTableSpec',
    //   searchType: 'partner',
    //   extraData: {
    //     departmentCode: ctx.baseInfoData.departmentCode,
    //     companyCode: ctx.baseInfoData.companyNo, //选择公司后的客户名称
    //   },
    //   isMultiple: true,
    //   changeMethod: 'changeMethod',
    //   currentValue: ctx.baseInfoData.customerName,
    // },
    {
      prop: 'customerNo',
      name: '客户名称',
      type: 'searchTableSpec',
      searchType: 'partner',
      placeholder: '请输入客户名称',
      isMultiple: true,
      currentValue: ctx.baseInfoData.customerName,
      extraData: {
        companyCode: ctx.baseInfoData.companyCode,
        departmentCode: ctx.baseInfoData.departmentCode,
        partnerTypes: 'HZHB01,HZHB03,HZHB11,HZHB10',
      },
      changeMethod: 'changeMethod',
    },
    {
      name: '经办人',
      prop: 'contractOperaterName',
      type: 'input',
      disabled: true,
    },
    {
      name: '部门负责人',
      prop: 'contractSalesmanNo',
      type: 'searchTableSpec',
      searchType: 'personnel',
      isMultiple: true,
      currentValue: ctx.baseInfoData.contractSalesmanName,
      changeMethod: 'changeMethod',
    },
    {
      name: '合同签署日期',
      prop: 'signDate',
      type: 'date',
    },
    {
      name: '合同生效日期',
      prop: 'contractValidStart',
      type: 'date',
    },
    {
      name: '合同到期日期',
      prop: 'contractValidEnd',
      type: 'date',
    },
    {
      name: '合同数量',
      prop: 'purchaseQuantity',
      type: 'input',
      disabled: true,
    },
    {
      name: '收益方式',
      prop: 'incomeMethod',
      type: 'select',
      options: [
        { value: '01', label: '单独回票' },
        { value: '02', label: '回款比例' },
      ],
      changeMethod: 'changeMethod',
    },
    {
      name: '回票日期',
      prop: 'replyInvoiceDate',
      type: 'date',
      // append: '天',
    },
    {
      name: '是否有违约责任',
      prop: 'isDefault',
      type: 'checkbox',
      labelPosition: 'right',
      falseLable: '0',
      trueLable: '1',
      changeMethod: 'changeMethod',
    },
    {
      apiData: { dictType: 'liquidatedDamages' },
      type: 'dictSelect',
      name: '合同违约金类型',
      prop: 'liquidatedDamagesType',
      changeMethod: 'changeMethod',
      disabled: ctx.baseInfoData?.isDefault == '0',
      placeholder: '请选择',
    },
    {
      name: '违约金固定值',
      prop: 'liquidatedFixedValue',
      type: 'inputNumber',
      append: '元',
      placeholder: '请输入违约金固定值',
      disabled:
        ctx.baseInfoData?.isDefault == '0' || ctx.baseInfoData.liquidatedDamagesType == '01',
    },
    {
      name: '违约金日利率',
      prop: 'liquidatedInterestRate',
      type: 'inputNumber',
      append: '%',
      placeholder: '请输入违约金日利率',
      disabled:
        ctx.baseInfoData?.isDefault == '0' || ctx.baseInfoData.liquidatedDamagesType == '02',
    },
    {
      name: '溢装比例',
      prop: 'overShippedPercentage',
      type: 'inputNumber',
      append: '%',
      changeMethod: 'changeMethod',
    },
    {
      name: '短装比例',
      prop: 'shortShippedPercentage',
      type: 'input',
      append: '%',
    },
    {
      name: '外部合同号（采购端）',
      prop: 'cgExternalContractNo',
      type: 'input',
    },
    {
      name: '最晚付款日',
      prop: 'lastestPayMoneyDay',
      type: 'date',
    },
    {
      name: '最晚收货日',
      prop: 'lastestReceiveProductDay',
      type: 'date',
    },
    {
      name: '预付',
      prop: 'isPrepay',
      type: 'checkbox',
      labelPosition: 'right',
      falseLable: '0',
      trueLable: '1',
      changeMethod: 'changeMethod',
    },
    {
      name: '预付金额',
      prop: 'creditAmount',
      type: 'inputNumber',
      disabled: ctx.baseInfoData?.isPrepay == '0',
      placeholder: '请输入预付金额',
    },
    {
      name: '付款方式',
      prop: 'cgReceiptMethod',
      type: 'dict',
      dictType: 'pay_method',
      changeMethod: 'changeMethod',
    },
    {
      name: '采购货币',
      prop: 'cgContractCurrency',
      type: 'dict',
      dictType: 'all_currency',
      changeMethod: 'changeMethod',
    },
    {
      name: '外部合同号（销售端）',
      prop: 'ssExternalContractNo',
      type: 'input',
    },
    // {
    //   name: '逾期周期',
    //   prop: 'overduePeriod',
    //   type: 'inputNumber',
    //   append: '天',
    // },
    // {
    //   prop: 'settlementDate',
    //   name: '结算日',
    //   apiUrl: BASE_API.DIC_CREDIT_API,
    //   apiData: { dictType: 'settlementDate' },
    //   type: 'ajaxSelect',
    //   placeholder: '请选择结算日',
    //   changeMethod: 'changeMethod',
    // },
    // {
    //   name: '结算日',
    //   prop: 'settlementDate',
    //   type: 'date',
    //   // options: [
    //   //   { value: '01', label: '开票日期' },
    //   //   { value: '02', label: '发货日期' },
    //   // ],
    // },
    {
      name: '质保金收取方式',
      prop: 'qualityGuaranteeDepositMethodCode',
      // apiData: { dictType: 'qualityGuaranteeDepositMethod' },
      // type: 'dictSelect',
      type: 'select',
      options: ctx.qualityGuaranteeDepositMethodCodeList,
      disabled: ctx.baseInfoData.isDefault == '0',
      changeMethod: 'changeMethod',
      placeholder: '请选择',
    },
    {
      name: '收取固定值',
      prop: 'chargeFixedValue',
      type: 'input',
      disabled:
        ctx.baseInfoData.qualityGuaranteeDepositMethodCode == '02' ||
        ctx.baseInfoData.isDefault == '0',
      placeholder: '请输入收取固定值',
    },
    {
      name: '收取比例',
      prop: 'chargeProportion',
      type: 'input',
      disabled:
        ctx.baseInfoData.qualityGuaranteeDepositMethodCode == '01' ||
        ctx.baseInfoData.isDefault == '0',
      placeholder: '请输入收取比例',
    },
    {
      name: '质保金逾期期限',
      prop: 'qualityGuaranteeDepositOverdue',
      type: 'inputNumber',
      append: '天',
      disabled: ctx.translateIsDefault,
      placeholder: '请输入质保金逾期期限',
    },
    {
      name: '保证金',
      prop: 'marginAmount',
      type: 'input',
    },
    {
      name: '收款方式',
      prop: 'ssReceiptMethod',
      type: 'dict',
      dictType: 'receiveMethod',
    },
    {
      name: '销售货币',
      prop: 'ssContractCurrency',
      type: 'dict',
      dictType: 'all_currency',
    },
    {
      name: '是否定量',
      prop: 'isRestrict',
      type: 'select',
      options: [
        { value: '1', label: '是' },
        { value: '0', label: '否' },
      ],
    },
    {
      name: '是否长期合同',
      prop: 'isLongRange',
      type: 'select',
      options: [
        { value: '1', label: '是' },
        { value: '0', label: '否' },
      ],
    },
  ];
};

export const baseRules = (ctx) => {
  return {
    contractCreateDate: [{ required: true, message: '请选择制单日期', trigger: 'change' }],
    contractName: [{ required: true, message: '请输入合同名称', trigger: 'blur' }],
    companyCode: [{ required: true, message: '请选择公司', trigger: 'change' }],
    departmentCode: [{ required: true, message: '请选择业务部门', trigger: 'change' }],
    projectInitiationNo: [{ required: true, message: '请选择项目编号', trigger: 'change' }],
    supplierNo: [{ required: true, message: '请选择供应商名称', trigger: 'change' }],
    customerNo: [{ required: true, message: '请选择客户名称', trigger: 'change' }],
    contractSalesmanNo: [{ required: true, message: '请选择部门负责人', trigger: 'change' }],
    cgContractCurrency: [{ required: true, message: '请选择采购货币', trigger: 'change' }],
    settlementDate: [{ required: true, message: '请选择结算日', trigger: 'change' }],
    isRestrict: [{ required: true, message: '请选择是否定量', trigger: 'change' }],
    isLongRange: [{ required: true, message: '必填字段', trigger: 'change' }],
    overduePeriod: [{ validator: isIntValidator, trigger: 'blur' }],
    qualityGuaranteeDepositOverdue: [{ validator: isIntValidator, trigger: 'blur' }],
    creditAmount: [
      { required: ctx.baseInfoData?.isPrepay != '0', message: '必填字段', trigger: 'blur' },
    ],
  };
};
